import React from "react";
import InlineHTML from "./index";
import styled from "styled-components";

const Wrapper = styled.div`
  min-height: 100px;
  border-left: 4px solid ${(p) => p.theme.background.info};
  padding-left: 5px;
`;

const InlineHTMLEdit = (props) => {
  const { extra = {} } = props;
  const { code = "" } = extra;

  return (
    <Wrapper>
      <InlineHTML {...props} />
    </Wrapper>
  );
};

export default InlineHTMLEdit;
